export default "__VITE_ASSET__Bqw1Mcnu__"